<template>
  <div class="min-h-screen">
    <div class="flex min-h-screen">
      <aside class="hidden w-[190px] shrink-0 border-r border-slate-200 bg-white lg:block">
        <div class=" py-5">
          <div class="flex items-center justify-between px-5">
            <div>
              <div class="text-sm font-bold text-slate-900">Admin Portal</div>
        
            </div>
           
          </div>

          <!-- <div class="mt-4 rounded-xl bg-slate-50 p-3 ring-1 ring-slate-200">
            <div class="text-xs font-semibold text-slate-700">{{ user?.name }}</div>
            <div class="mt-0.5 text-[11px] text-slate-500">@{{ user?.username }}</div>
          </div> -->
          <br>
          <hr>
        </div>

        <nav class=" pb-6">
          <RouterLink v-for="item in nav" :key="item.to" :to="item.to"
            class="group flex items-center justify-between  px-3 py-2 text-sm font-semibold transition"
            :class="isActive(item.to) ? 'w-full bg-sky-50 text-sky-700' : 'w-full text-slate-700 hover:bg-slate-50'">
            <span class="flex items-center gap-2">
              <span class="text-base">{{ item.icon }}</span>
              {{ item.label }}
            </span>
    
          </RouterLink>
     
          <!-- <button
            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
            @click="logout"
          >
            Sign out
          </button> -->
        </nav>

     
      </aside>

      <div class="flex min-w-0 flex-1 flex-col">
        <header class="sticky top-0 z-10 border-b border-slate-200 bg-white/80 backdrop-blur">
          <div class="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
            <div class="flex min-w-0 items-center gap-3 lg:gap-0">
              <button
                type="button"
                class="inline-flex shrink-0 items-center justify-center rounded-lg p-1.5 text-slate-700 hover:bg-slate-100/80 active:bg-slate-100 lg:hidden"
                aria-label="Open menu"
                @click="navOpen = true"
              >
                <svg
                  class="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  aria-hidden="true"
                >
                  <path d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <div class="min-w-0">
                <div class="truncate text-sm font-bold text-slate-900">PM System</div>
                <!-- <div class="mt-0.5 text-xs text-slate-500">Admin</div> -->
              </div>
            </div>
            <div class="flex items-center gap-2">
              <button
             @click="logout"
                class="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm hover:bg-slate-50 "
              >
                Logout
            </button>
            
            </div>
          </div>
        </header>

        <main class="mx-auto w-full max-w-6xl flex-1 px-4 py-6 pb-24 lg:pb-6">
          <RouterView />
        </main>

        <footer class="border-t border-slate-200 bg-white">
          <div class="mx-auto max-w-6xl px-4 py-4 text-xs text-slate-500">
           Powerd By Abima Business Solutions
          </div>
        </footer>

        <!-- Mobile bottom nav -->
        <nav class="fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-white/90 backdrop-blur lg:hidden">
          <div class="mx-auto max-w-6xl px-2">
            <div class="grid grid-cols-5 gap-1 py-2">
              <RouterLink
                v-for="item in mobileNav"
                :key="item.to"
                :to="item.to"
                class="flex flex-col items-center justify-center rounded-lg px-2 py-1.5 text-[11px] font-semibold transition"
                :class="isActive(item.to) ? 'bg-sky-50 text-sky-700' : 'text-slate-600 hover:bg-slate-50'"
              >
                <div class="text-base leading-none">{{ item.icon }}</div>
                <div class="mt-1 truncate">{{ item.shortLabel }}</div>
              </RouterLink>
            </div>
          </div>
        </nav>
      </div>

    <!-- Mobile sidebar drawer -->
    <Transition
      enter-active-class="transition-opacity duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="navOpen"
        class="fixed inset-0 z-[35] bg-slate-900/40 lg:hidden"
        aria-hidden="true"
        @click="navOpen = false"
      />
    </Transition>
    <Transition
      enter-active-class="transition-transform duration-200 ease-out"
      enter-from-class="-translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="transition-transform duration-200 ease-in"
      leave-from-class="translate-x-0"
      leave-to-class="-translate-x-full"
    >
      <aside
        v-if="navOpen"
        class="fixed left-0 top-0 z-[45] flex h-full w-[190px] max-w-[85vw] flex-col border-r border-slate-200 bg-white shadow-xl lg:hidden"
        role="dialog"
        aria-modal="true"
        aria-label="Admin navigation"
      >
        <div class="py-5">
          <div class="flex items-center justify-between px-5">
            <div class="text-sm font-bold text-slate-900">Admin Portal</div>
            <button
              type="button"
              class="rounded-lg p-1.5 text-slate-600 hover:bg-slate-100"
              aria-label="Close menu"
              @click="navOpen = false"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <br />
          <hr />
        </div>
        <nav class="flex-1 overflow-y-auto pb-6">
          <RouterLink
            v-for="item in nav"
            :key="item.to"
            :to="item.to"
            class="group flex items-center px-3 py-2 text-sm font-semibold transition"
            :class="isActive(item.to) ? 'w-full bg-sky-50 text-sky-700' : 'w-full text-slate-700 hover:bg-slate-50'"
            @click="navOpen = false"
          >
            <span class="flex min-w-0 items-center gap-2">
              <span class="text-base">{{ item.icon }}</span>
              <span class="truncate">{{ item.label }}</span>
            </span>
          </RouterLink>
        </nav>
      </aside>
    </Transition>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { toast } from "@/toast";

const store = useStore();
const route = useRoute();
const router = useRouter();

const navOpen = ref(false);

watch(
  () => route.fullPath,
  () => {
    navOpen.value = false;
  }
);

function onKeydown(e) {
  if (e.key === "Escape") navOpen.value = false;
}

onMounted(() => window.addEventListener("keydown", onKeydown));
onUnmounted(() => window.removeEventListener("keydown", onKeydown));

// const user = computed(() => store.getters.authedUser);
const expiredCount = computed(() => store.getters.expiredPermanentCustomers.length);

const nav = computed(() => [
  { to: "/admin/dashboard", label: "Dashboard", icon: "📊" },
  { to: "/admin/permanent-customers", label: "Permanent Users", icon: "🧾", badge: expiredCount.value ? `${expiredCount.value} expired` : "" },
  { to: "/admin/operators", label: "Gate Operators", icon: "👤" },
  { to: "/admin/reports", label: "Reports", icon: "💰" },
  { to: "/admin/logs", label: "Audit Logs", icon: "🧩" },
  { to: "/admin/settings", label: "Pricing & Settings", icon: "⚙️" },
]);

const mobileNav = computed(() => [
  { to: "/admin/dashboard", shortLabel: "Home", icon: "📊" },
  { to: "/admin/permanent-customers", shortLabel: "Users", icon: "🧾" },
  { to: "/admin/reports", shortLabel: "Reports", icon: "💰" },
  { to: "/admin/logs", shortLabel: "Logs", icon: "🧩" },
  { to: "/admin/settings", shortLabel: "Settings", icon: "⚙️" },
]);

function isActive(path) {
  return String(route.path || "").startsWith(path);
}

async function logout() {
  await store.dispatch("logout");
  toast.info("Signed out.");
  router.push("/login");
}
</script>

